interface ContactUsInformationSlice {
    sector: string;
    subSector: string;
    categories: string[];
    topics: { [query: string]: string[] };
}

const contactUsForm = $('[contact-us-form]');

if (contactUsForm.length > 0) {
    const informationList: ContactUsInformationSlice[] = parseObject(contactUsForm.data('topic-list'));


    informationList.forEach((x) => (x.topics = rebuildTopics(x.topics)));

    const hideIataCodeIfValues =[ "airline", "freight forwarder", "gsa", "travel agent"];

    const sectorSelect = contactUsForm.find('select[name=Sector]');
    const subsectorSelect = contactUsForm.find('select[name=SubSector]');
    const categoriesSelect = contactUsForm.find('select[name=Category]');
    const querySelect = contactUsForm.find('select[name=QueryCategory]');
    const topicsSelect = contactUsForm.find('select[name=Topic]');
    const iataCodeLabel = contactUsForm.find('label[name=IataCodeLabel]');
    const iataCodeInput = contactUsForm.find('input[name=IataCode]');
    const topicFirstElement = contactUsForm.find('input[name=topicFirstElement]');
    const queryStringFirstElement = contactUsForm.find('input[name=queryStringFirstElement]');
    const subSectorFirstElement = contactUsForm.find('input[name=subSectorFirstElement]');
    const categoryFirstElement = contactUsForm.find('input[name=categoryFirstElement]');


    //updateIataCode();
    updateSubsectors();

    sectorSelect.change(() => {
        updateSubsectors();
        updateCategories();
        updateQuery();
        updateTopics();
        updateIataCode();
    });

    subsectorSelect.change(() => {
        updateCategories();
        updateQuery();
        updateTopics();
    });

    querySelect.change(() => {
        updateTopics();
    });


    function updateIataCode() {
        const currentSectorValue = sectorSelect.val() as string;

        if (hideIataCodeIfValues.includes(currentSectorValue.toLowerCase())) {
            iataCodeLabel.show();
            iataCodeInput.show();
        }
        else {
            iataCodeLabel.hide();
            iataCodeInput.hide();
        }
    }

    function updateTopics() {
        const validTopics = getValidTopics();
        updateOptionsList(topicsSelect, validTopics, topicFirstElement.val().toString());

        function getValidTopics(): string[] {
            const currentSector = sectorSelect.val() as string;
            const currentSubsector = subsectorSelect.val() as string;
            const currentQuery = querySelect.val() as string;

            const currentInformation = findCurrentInformation(currentSector, currentSubsector);

            if (!currentInformation) {
                return [];
            }

            return currentInformation.topics[currentQuery] || [];
        }
    }

    function findCurrentInformation(currentSector: string, currentSubsector: string) {
        currentSector = currentSector || '';
        currentSubsector = currentSubsector || '';
        return informationList.find((x) => x.sector == currentSector && x.subSector == currentSubsector);
    }

    function updateQuery() {
        const validQueries = getValidQueries();
        updateOptionsList(querySelect, validQueries, queryStringFirstElement.val().toString());

        function getValidQueries(): string[] {
            const currentSector = sectorSelect.val() as string;
            const currentSubsector = subsectorSelect.val() as string;

            const currentInformation = findCurrentInformation(currentSector, currentSubsector);

            if (!currentInformation) {
                return [];
            }

            const matchingQueries = Object.keys(currentInformation.topics).filter(
                (query) => (currentInformation.topics[query] || []).length > 0,
            );

            return matchingQueries;
        }
    }

    function updateCategories() {
        const validCategories = getValidCategories();
        updateOptionsList(categoriesSelect, validCategories, categoryFirstElement.val().toString());

        function getValidCategories(): string[] {
            const currentSector = sectorSelect.val() as string;
            const currentSubsector = subsectorSelect.val() as string;

            const currentInformation = findCurrentInformation(currentSector, currentSubsector);
            return currentInformation ? currentInformation.categories : [];
        }
    }

    function updateSubsectors() {
        const validSubsectors = getValidSubsectors();
        updateOptionsList(subsectorSelect, validSubsectors,subSectorFirstElement.val().toString());

        const parentToHide = subsectorSelect.parent('[data-parent-to-hide]');
        if (validSubsectors.length == 0) {
            parentToHide.hide();
        } else {
            parentToHide.show();
        }

        function getValidSubsectors(): string[] {
            const currentSector = sectorSelect.val();
            return informationList
                .filter((x) => x.sector == currentSector)
                .map((x) => x.subSector)
                .filter((subSector) => subSector);
        }
    }

    function updateOptionsList(select: JQuery<HTMLElement>, options: string[], firstOption: string): void {
        select.empty();

        var opt = document.createElement('option');
        opt.value = '';
        opt.innerHTML = firstOption;
        select.append(opt);

        select.append(options.sort(function (a, b) {
            let x = a.toLowerCase(),
                y = b.toLowerCase();
            if (x < y) { return -1; }
            if (y < x) { return 1; }
            return 0;
        })
            .map((x) => `<option value="${x}">${x}</option>`).join(''));
    }
}

function rebuildTopics(topic: { [query: string]: string[] }): { [query: string]: string[] } {
    const newTopic: { [query: string]: string[] } = {};

    const keys = Object.keys(topic);
    const newKeys = keys.map((x) => uppercaseFirstLetter(x)).map((x) => ensureIataIsCapitalized(x));
    for (let i = 0; i < keys.length; i++) {
        var key = keys[i];
        let newKey = newKeys[i];

        newTopic[newKey] = topic[key];
    }
    return newTopic;

    function uppercaseFirstLetter(value: string) {
        return value[0].toUpperCase() + value.slice(1);
    }

    function ensureIataIsCapitalized(value: string) {
        return value.replace(/\biata\b/i, 'IATA');
    }
}

function parseObject(value: any) {
    return JSON.parse(decodeHtml(value));

    function decodeHtml(value: any): string {
        const textArea = document.createElement('textarea');
        textArea.innerHTML = value;
        return textArea.value;
    }
}
